var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidayLeftbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2739_18580)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2739_18580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06226 0.499023C3.17829 0.499023 3.28957 0.545117 3.37161 0.627164C3.45366 0.709211 3.49976 0.820491 3.49976 0.936523V1.37402H10.4998V0.936523C10.4998 0.820491 10.5458 0.709211 10.6279 0.627164C10.7099 0.545117 10.8212 0.499023 10.9373 0.499023C11.0533 0.499023 11.1646 0.545117 11.2466 0.627164C11.3287 0.709211 11.3748 0.820491 11.3748 0.936523V1.37402H12.2498C12.7139 1.37402 13.159 1.5584 13.4872 1.88659C13.8154 2.21478 13.9998 2.65989 13.9998 3.12402V12.749C13.9998 13.2132 13.8154 13.6583 13.4872 13.9865C13.159 14.3146 12.7139 14.499 12.2498 14.499H1.74976C1.28563 14.499 0.840508 14.3146 0.512319 13.9865C0.18413 13.6583 -0.000244141 13.2132 -0.000244141 12.749V3.12402C-0.000244141 2.65989 0.18413 2.21478 0.512319 1.88659C0.840508 1.5584 1.28563 1.37402 1.74976 1.37402H2.62476V0.936523C2.62476 0.820491 2.67085 0.709211 2.7529 0.627164C2.83494 0.545117 2.94622 0.499023 3.06226 0.499023ZM1.74976 2.24902C1.51769 2.24902 1.29513 2.34121 1.13104 2.50531C0.966943 2.6694 0.874756 2.89196 0.874756 3.12402V12.749C0.874756 12.9811 0.966943 13.2036 1.13104 13.3677C1.29513 13.5318 1.51769 13.624 1.74976 13.624H12.2498C12.4818 13.624 12.7044 13.5318 12.8685 13.3677C13.0326 13.2036 13.1248 12.9811 13.1248 12.749V3.12402C13.1248 2.89196 13.0326 2.6694 12.8685 2.50531C12.7044 2.34121 12.4818 2.24902 12.2498 2.24902H1.74976Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.18726 3.99902C2.18726 3.88299 2.23335 3.77171 2.3154 3.68966C2.39744 3.60762 2.50872 3.56152 2.62476 3.56152H11.3748C11.4908 3.56152 11.6021 3.60762 11.6841 3.68966C11.7662 3.77171 11.8123 3.88299 11.8123 3.99902V4.87402C11.8123 4.99006 11.7662 5.10134 11.6841 5.18338C11.6021 5.26543 11.4908 5.31152 11.3748 5.31152H2.62476C2.50872 5.31152 2.39744 5.26543 2.3154 5.18338C2.23335 5.10134 2.18726 4.99006 2.18726 4.87402V3.99902ZM7.87476 7.49902C7.87476 7.26696 7.96694 7.0444 8.13104 6.88031C8.29513 6.71621 8.51769 6.62402 8.74976 6.62402H13.1248V8.37402H8.74976C8.51769 8.37402 8.29513 8.28184 8.13104 8.11774C7.96694 7.95365 7.87476 7.73109 7.87476 7.49902ZM0.874756 9.24902H4.37476C4.60682 9.24902 4.82938 9.34121 4.99347 9.50531C5.15757 9.6694 5.24976 9.89196 5.24976 10.124C5.24976 10.3561 5.15757 10.5786 4.99347 10.7427C4.82938 10.9068 4.60682 10.999 4.37476 10.999H0.874756V9.24902Z",
    fill: "#212529"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2739_18580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2739_18580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayLeftbarIcon);
export default __webpack_public_path__ + "static/media/holiday_leftbar_icon.a86ab063f0677e79770a28c587c141ab.svg";
export { ForwardRef as ReactComponent };